export default "__VITE_ASSET__CEOViF6j__"